<template>
  <div class="take-back">
    <div class="attr-label"><p>{{ label }}</p></div>
    <div class="attr-content" v-if="bonus">
      <p class="date">Du {{ startDate }} au {{ endDate }}</p>
      <p><strong>{{ formatPrice(bonus.montant) }} de bonus reprise</strong> pour l'achat de ce téléphone et la souscription du forfait sélectionné si vous vendez votre ancien mobile</p>
    </div>
    <div class="attr-items">
      <div class="item" :class="{ 'active': takeBack }" @click.prevent="openPopup">Oui</div>
      <div class="item" :class="{ 'active': !takeBack }">Non</div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'

export default {
  name: 'TakeBack',
  props: {
    label: String
  },
  data () {
    return {
      takeBack: false
    }
  },
  computed: {
    ...mapState({
      phone: state => state.phone.item,
      loading: state => state.phone.loading
    }),
    bonus () {
      let bonus = null
      this.phone.offers.forEach((offer) => {
        if(offer.typePromotion.nom === 'BONUS REPRISE') {
          bonus = offer
        }
      })
      return bonus
    },
    startDate () {
      let date = null
      if(this.bonus){
        date = new Date(this.bonus.debut)
        date = this.formatDate(date)
      }
      return date
    },
    endDate () {
      let date = null
      if(this.bonus){
        date = new Date(this.bonus.fin)
        date = this.formatDate(date)
      }
      return date
    }
  },
  methods: {
    ...mapActions('takeBack', ['openPopup']),
    padTo2Digits(num) {
      return num.toString().padStart(2, '0');
    },
    formatDate(date) {
      return [
        this.padTo2Digits(date.getDate()),
        this.padTo2Digits(date.getMonth() + 1),
        date.getFullYear(),
      ].join('/')
    },
    formatPrice (amount) {
      return new Intl.NumberFormat('fr-FR', {
        style: 'currency',
        currency: 'EUR',
        minimumFractionDigits: 0,
        maximumFractionDigits: 0
      }).format(amount)
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../../../scss/tools/*';
@import '../../../../scss/mixins/*';

.take-back{
  margin-bottom: 20px;

  .attr-label {
    margin-bottom: 15px;

    p {
      font-size: px2rem(15px);
      line-height: px2rem(22px);
      font-weight: $fontSemiBold;
    }
  }

  .attr-content{
    margin-bottom: 10px;

    p{
      font-size: px2rem(14px);
      line-height: px2rem(19px);
      font-weight: $fontRegular;
      margin-bottom: 5px;

      &.date{
        font-size: px2rem(12px);
        line-height: px2rem(17px);
        font-weight: $fontRegular;
      }

      strong{
        font-weight: $fontSemiBold;
        color: $primary;
      }
    }
  }

  .attr-items{
    .item{
      width: auto;
      height: 50px;
      line-height: 28px;
      border: 1px solid darken($white, 10%);
      margin: 0 10px 0 0;
      position: relative;
      cursor: pointer;
      padding: 10px 20px;
      text-transform: capitalize;
      @include radius(5px);
      @include transition();

      &:after {
        display: inline-block;
        content: '';
        position: absolute;
        top: -1px;
        left: -1px;
        width: calc(100% - 2px);
        height: calc(100% - 2px);
        border: 2px solid $black;
        opacity: 0;
        @include radius(5px);
        @include transition();
      }

      &:hover {
        &:after {
          opacity: 1;
        }
      }

      &.active {
        color: $primary;

        &:after {
          opacity: 1;
          border: 2px solid $primary;
        }
      }
    }
  }
}
</style>
